import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { init } from '../../auth/handleTokens';
import { constants } from '../../constants';
import NotificationContext from '../toasts/NotificationContext';

const AddCredits = (props) => {

  const toggle = props.toggleSidebar ? '0px' : '0px'
  const {showNotification} = useContext(NotificationContext);
  const [numpack, setNumpack] = useState('');
  const [identification, setIdentification] = useState('');
  const [stringCode, setStringCode] = useState('');
  const [sendingGetCode, setSendingGetCode] = useState(false);
  const [sendingActiveCode, setSendingActiveCode] = useState(false);

  const inputCodeRef = useRef();

  const packSelect = (target) => {
    console.log(`paquete seleccionado: ${target.value}`)
    setNumpack(target.value);
  }
   
  const getStringCode = async() => {
    const result = await init();
    if(!result) return window.location.href = '/login';
    const token = window.localStorage.getItem('at');
    const URL = constants.test_host + '/admin/genpackcode';
    setSendingGetCode(true);
    await axios.post(URL,{numpack, identification},{headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true})
    .then(({data})=> {
      showNotification('success', data.message);
      setSendingGetCode(false);
      inputCodeRef.current.focus();
    }).catch((err) => {
      showNotification('failed', err.response.data.message)
      setSendingGetCode(false);
    })
  }  

  const activateCode = async() => {
    const result = await init();
    if(!result) return window.location.href = '/login';
    const token = window.localStorage.getItem('at');
    const URL = constants.test_host + '/admin/addcredits';
    setSendingActiveCode(true);
    await axios.post(URL,{stringCode},{headers: {'Content-Type': 'application/json', 'authorization': `Bearer ${token}`}, withCredentials: true})
    .then(({data})=> {
      showNotification('success', data.message);
      setSendingActiveCode(false);
      inputCodeRef.current.focus();
      setIdentification('');
      setStringCode('');
    }).catch((err) => {
      showNotification('failed', err.response.data.message);
      setSendingActiveCode(false)
    })
  }

  return (
    <div className="content-wrapper content shadow-lg" style={{ marginLeft: `${toggle}`, transition: "all 0.5s",  paddingLeft: '20px', textAlign: 'center'}} >
      <div className='container'>
      <h4 className='subtitle'><strong>Activación de créditos</strong></h4>
      <form className="row justify-content-center">
            <div style={{fontSize: 'medium'}} className="col-auto form-floating form-outline">
              <div>
                <p style={{fontSize: '15px'}}>Selecciona el paquete</p>
                <select style={{marginBottom: '5px'}} onChange={(e) => packSelect(e.target)}>
                  <option value={0}>Selecciona</option>
                  <option value={150}>Pack 150</option>
                  <option value={350}>Pack 350</option>
                  <option value={750}>Pack 750</option>
                </select>
                <input
                  type="number"
                  className="form-control"
                  id="identification"
                  name='identification'
                  required
                  value={identification}
                  onChange= {({target}) => setIdentification(target.value)}
                  placeholder= 'Identificación'
                  style={{maxHeight: '40px', fontSize:'small'}}
                />
                <br />
                {sendingGetCode ? <button class="btn btn-primary btn-sm" type="button" disabled>
                          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                          Enviando...
                        </button>:
                <button style={{marginTop: '5px'}} className='btn btn-sm btn-primary' onClick={()=> getStringCode()}>Solicitar Código</button>}

              </div>
              <hr />
              <div>
                <input
                  ref={inputCodeRef}
                  type="text"
                  className="form-control"
                  id="stringCode"
                  name='stringCode'
                  required
                  value={stringCode}
                  onChange= {({target}) => setStringCode(target.value)}
                  placeholder= 'Código de activación'
                  style={{maxHeight: '40px', fontSize:'small'}}
                />

                {sendingActiveCode ? <button class="btn btn-primary btn-sm" type="button" disabled>
                          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                          Enviando...
                        </button>:
                <button style={{marginTop: '5px'}} type='button' onClick={activateCode} className="btn btn-sm btn-primary mb-3">
                  Enviar
                </button>}

              </div>
            </div>
            

            
          </form>

      

          <div>
         
        </div>

      </div>

      
    </div>
  )
}

export default AddCredits
